import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

export type ClinicalCodeWithTransformations = ReturnType<typeof useClinicalCodeWithTransformations>["data"];

export const useClinicalCodeWithTransformations = (codeId: string, enabled: boolean = true) => {
  const result = useQuery({
    queryKey: ["clinical-code-with-transformations", codeId],
    queryFn: async () => {
      const [
        { data: clinicalCodeTransformation, error: clinicalCodeTransformationError },
        { data: clinicalCode, error: clinicalCodeError },
      ] = await Promise.all([
        supabase
          .from("clinical_code_transformations")
          .select(
            `
             *,
            condition_sets:clinical_code_transformation_condition_sets (
              id,
              name,
              transformation_id,
              conditions:clinical_code_transformation_conditions (
                id,
                operator,
                field_id,
                datapoint_id,
                fields (
                  id,
                  name
                ),
                datapoints (
                  id,
                  name
                )
              )
            )
            `,
          )
          .eq("code_id", codeId),
        supabase.from("clinical_codes").select("*").eq("id", codeId).maybeSingle(),
      ]);

      if (clinicalCodeError || clinicalCodeTransformationError) {
        throw new Error("Failed to fetch clinical code with transformations");
      }

      return {
        ...(clinicalCode || {}),
        condition_sets: clinicalCodeTransformation?.flatMap((transformation) => transformation.condition_sets) ?? [],
      };
    },
    enabled: enabled && !!codeId,
  });

  return result;
};
